import { ButtonV2 } from '@findy-code/yuffie/ui/button/v2';

type Props = {
  isKeep?: boolean;
  likeHash: string;
  onClick?: (likeHash: string, isKeep: boolean) => void;
};

export const KeepButton = ({ isKeep = false, likeHash, onClick }: Props) => (
  <ButtonV2
    disabled={isKeep}
    subVariant="negative"
    type="button"
    variant="secondary"
    onClick={() => onClick?.(likeHash, isKeep)}
  >
    {isKeep ? 'お見送り済み' : '今回は見送る'}
  </ButtonV2>
);
